import React from 'react'
// Style components
import {makeStyles} from '@material-ui/core/styles'
import {AppBar, CssBaseline} from '@material-ui/core'

// Nav Menu amd Routing Components
import Nav from '../components/Nav'
import {Switch, Route, Redirect} from 'react-router-dom'
import withCheckLoginState from '../components/withCheckLoginState'
import NotFound from './NotFound'

// Menu Components
import ManageRolesHome from './Home/ManageRolesHome'
import SwiperHome from './Home/SwiperHome'
import EventSetupHome from './Home/EventSetupHome'
import SwipeTeams from './Home/EventSetupHome/SwiperTeams'
import SuperAdminRoles from './Home/ManageRolesHome/SuperAdminRoles'
import AuditAllDeptRoles from './Home/ManageRolesHome/AuditAllDeptRoles'

// using hook API
const useStyles = makeStyles(theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: 'none',
    },
}))

const Home = props => {
    const classes = useStyles()
    const {userrole, activedeptuserrole} = props

    return (
        <>
            <CssBaseline />
            <div>
                <AppBar className={classes.appBar}>
                    <Nav
                        userrole={userrole}
                        activedeptuserrole={activedeptuserrole}
                    />
                </AppBar>

                <Switch>
                    <Route exact path={'/eventsetup'}>
                        <EventSetupHome />
                    </Route>
                    <Route exact path={'/swipeteams'}>
                        <SwipeTeams />
                    </Route>
                    <Route exact path={'/swiping'}>
                        <SwiperHome />
                    </Route>
                    <Route exact path={'/manageroles'}>
                        <ManageRolesHome
                            activedeptuserrole={activedeptuserrole}
                        />
                    </Route>
                    <Route exact path={'/superadminroles'}>
                        <SuperAdminRoles />
                    </Route>
                    <Route exact path={'/auditalldeptroles'}>
                        <AuditAllDeptRoles />
                    </Route>
                    <Route exact path={'/'}>
                        {userrole === 'Super Admin' ? (
                            <Redirect to="/manageroles" />
                        ) : ['Department Admin', 'Department Creator'].includes(
                              userrole
                          ) ? (
                            <Redirect to="/eventsetup" />
                        ) : (
                            <Redirect to="/swiping" />
                        )}
                    </Route>
                    <Route path={'*'}>
                        <NotFound />
                    </Route>
                </Switch>
            </div>
        </>
    )
}

export default withCheckLoginState(Home)
